import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Landing from 'views/public/landing/Landing.js'

import { LinearProgress, MuiThemeProvider } from '@material-ui/core'
import { lightTheme } from 'config/theme'
import Template from 'components/Template'
import CssBaseline from '@material-ui/core/CssBaseline'
import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ConfirmProvider } from 'material-ui-confirm'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { fetchConference, fetchConferenceById } from 'store/conference'
import { Roles } from 'constants/index'
import moment from 'moment'
import 'moment-timezone'
import { isEmpty } from 'lodash'
import SubjectSubmissionForm from 'views/admin/subjects/SubjectSubmissionForm'
import PoolForm from 'views/admin/polling/public/PoolForm'
import ModeratorsLogin from './views/moderators/public/Login'
import ModeratorTemplate from './views/moderators/ModeratorTemplate'
import EventPolls from 'views/moderators/polling/EventPolls'
import PollView from './views/moderators/polling/PollView'
import { EventProvider, SessionProvider } from 'context'
import SubjectTalkForm from 'views/admin/subjects/HTMLForms/SubjectTalkForm'
import PollPresentation from 'views/moderators/polling/PollPresentation'
import PrivacyPolicy from 'views/public/PrivacyPolicy'
import NotFound from 'components/NotFound'
import { fetchSettings } from 'store/settings'
toast.configure()

const App = () => {
  const { inProgress, user } = useSelector((state) => state.auth)
  const { conference } = useSelector((state) => state.conference)

  const dispatch = useDispatch()
  !isEmpty(conference) && moment.tz.setDefault(conference?.timezone)

  useEffect(() => {
    if (user && user.role === Roles.SUPER_ADMIN) {
      dispatch(fetchConference())
    } else if (user) {
      dispatch(fetchConferenceById(user.conferenceId))
      dispatch(fetchSettings(user?.conferenceId))
    }
  }, [user])

  return (
    <EventProvider>
      <SessionProvider>
        <MuiThemeProvider theme={lightTheme}>
          <ConfirmProvider>
            <CssBaseline />
            {inProgress ? (
              <LinearProgress color="secondary" />
            ) : (
              <Router>
                <Switch>
                  <Route path="/" exact>
                    <Landing />
                  </Route>
                  <Route path="/privacy-policy" exact>
                    <PrivacyPolicy />
                  </Route>

                  <Route path="/subjects/speaker" exact>
                    <SubjectSubmissionForm />
                  </Route>

                  <Route path="/subjects/speaker/talks/new" exact>
                    <SubjectTalkForm forApproval={false} />
                  </Route>

                  <Route path="/subjects/speaker/talks/edit/:talkId" exact>
                    <SubjectTalkForm forApproval={false} />
                  </Route>

                  <Route path="/subjects/exhibitor" exact>
                    <SubjectSubmissionForm />
                  </Route>

                  <Route path="/subjects/sponsor" exact>
                    <SubjectSubmissionForm />
                  </Route>

                  <Route path="/polling" exact>
                    <PoolForm />
                  </Route>

                  <Route path="/poll" exact>
                    <ModeratorsLogin />
                  </Route>
                  <Route path="/dashboard/polls" exact>
                    <ModeratorTemplate>
                      <EventPolls />
                    </ModeratorTemplate>
                  </Route>
                  <Route path="/polls/:pollId" exact>
                    <PollView />
                  </Route>
                  <Route path="/poll-presentation" exact>
                    <ModeratorTemplate>
                      <PollPresentation />
                    </ModeratorTemplate>
                  </Route>
                  <Route path="/admin">
                    <Template />
                  </Route>
                  <Route path="*">
                    <NotFound />
                  </Route>
                </Switch>
              </Router>
            )}
          </ConfirmProvider>
        </MuiThemeProvider>
      </SessionProvider>
    </EventProvider>
  )
}

export default App
